// Third-party imports

export function isInventoryTracked(incrementerCounter) {
    let inventoryTracked = incrementerCounter.data('inventoryTracked');
    return inventoryTracked;
}

// Returns TRUE if the cart should be updated with the current counter value
// Also updates the counter value based on what action was taken
export function maxQuantityHandler(
    actionClass,
    incrementerCounter,
    counterValue,
    preCounterValue
) {
    let rVal = false;
    let maxInventory = incrementerCounter.data('maxInventory');

    if (actionClass === 'decrease' || actionClass === 'submit') {
        if (counterValue <= maxInventory && counterValue >= 0) {
            rVal = true;
        } else if (counterValue < 0) {
            incrementerCounter.val(preCounterValue);
        }
    } else if (actionClass === 'increase') {
        // If we increase TO zero, we don't remove from the cart
        if (counterValue <= maxInventory && counterValue > 0) {
            rVal = true;
        } else if (counterValue > maxInventory) {
            incrementerCounter.val(preCounterValue);
        }
    }

    return rVal;
}
